// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/bold.js';

import { paths } from '../generated/bold';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('bold', Original, paths);
